export default {
  path: "/contactus",
  name: "Contact Us",
  htmlContent: "contactus.html",
  headings: [],
};
